export interface IUser {
  UserID?: string;
  UserName?: string;
  Email?: string;
  EmailConfirmed?: number;
  isActive?: number;
  Roles?: string[]
}

export class User implements IUser {


  constructor();
  constructor(obj: IUser);
  constructor(obj?: IUser) {

  }
}
